import { render, staticRenderFns } from "./cleaningprices.vue?vue&type=template&id=b053bb1e&"
import script from "./cleaningprices.vue?vue&type=script&lang=js&"
export * from "./cleaningprices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b053bb1e')) {
      api.createRecord('b053bb1e', component.options)
    } else {
      api.reload('b053bb1e', component.options)
    }
    module.hot.accept("./cleaningprices.vue?vue&type=template&id=b053bb1e&", function () {
      api.rerender('b053bb1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27jJM3RswaXhi/JS/cleaningprices.vue"
export default component.exports